import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import querystring from 'query-string';
import invariant from 'invariant';

export default function updateDetails(params) {
    const { baseUrl, brandId, country, language, details, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of updateDetails()');
    invariant(brandId, 'brandId is a required param of updateDetails()');
    invariant(country, 'country is a required param of updateDetails()');
    invariant(language, 'language is a required param of updateDetails()');
    invariant(details, 'details is a required param of updateDetails()');
    invariant(uberToken, 'uberToken is a required param of updateDetails()');
    invariant(clientId, 'clientId is a required param of updateDetails()');

    const headers = { 'Content-Type': 'application/json' };
    const query = querystring.stringify({ brandId });
    const url = `${baseUrl}${language}-${country.toLowerCase()}/account/@self/details?${query}`;

    return labelRequest(
        authenticatedRequest(
            new Request(url, { headers: new Headers(headers), method: 'PUT', body: JSON.stringify(details) }),
            uberToken,
            clientId,
            clientSecret,
        ),
        'updateDetails',
    );
}
